import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ReauthenticationDetailsModel } from 'src/app/models/api/reauthentication-details.model';


/**
 * Api Client for the (BE) Api that can check whether additional verification is needed for the current logged in user based on Requests
 */
@Injectable({
  providedIn: 'root'
})
export class IdentificationVerificationApiClient {

  constructor(private httpClient: HttpClient) { }


  /**
   *  Verify whether for this request any additional verification is needed (based on current user)
   *  (cross references the current user)
   * @param requestGuid relevant for what request to verify 
   * @returns A model with IF NEEDED data to retrigger authentication
   */
  MakeVerifyIdentificationCall(requestGuid: string): Observable<ReauthenticationDetailsModel> {
    return this.httpClient.get<ReauthenticationDetailsModel>(environment.apiUrl + "/identification-verification/" + requestGuid);
  }
}

